module.exports = __webpack_public_path__ + "img/commitment.6d8d82ac.png";